<template>
    <div class="my_check_summaries">
        <div class="ui icon dropdown button" v-dropdown>
            <div v-if="is_processing" class="signal"></div>
            <i class="clipboard check large icon"></i>
            <!-- 列印點交單 -->
            <div class="menu" style="min-width: 280px;left: 0 !important;">
                <div class="header">
                    <CheckSummary
                        v-model="is_processing"
                        :scope="'provider'"
                        :conditions_search_params="{
                            current_handover: true,
                            all_staffs: true,
                            updated_at: {
                                from: latest_condition_from,
                                to: latest_condition_to
                            }
                        }"
                        :default_search_params="{
                            condition: {
                                name: 'current_handover',
                                polarity: true,
                                updated_at: {
                                    from: latest_condition_from,
                                    to: latest_condition_to,
                                }
                            },
                            pagination: false
                        }"
                        :is_beta="is_beta"
                        :channel_name="channel_name"
                        :title="'貨物交予 點交單'"
                        :sub_title="node.website_url"
                        :customer_service_hotline="node.customer_service_hotline"
                        :logo_url="logo_url"
                        :show_buttons="false"
                        :show_contents="false">
                    </CheckSummary>
                </div>
                <div class="ui divider"></div>
                <div class="custom_item">
                    <DatePicker
                        v-model="latest_condition_dates"
                        :is_row="true"
                        key="my_check_summaries"
                    >
                    </DatePicker>
                    <!-- <el-date-picker
                        class="next_input_row"
                        v-model="latest_condition_dates"
                        unlink-panels
                        type="datetimerange"
                        size="small"
                        align="center"
                        :start-placeholder="$t('ui.el.datepicker.startDate')"
                        :end-placeholder="$t('ui.el.datepicker.endDate')"
                        :picker-options="$store.state.element_ui_datepicker_daterange_options"
                        >
                    </el-date-picker> -->
                </div>
                <div class="custom_item" @click.prevent="refresh_data('custom_check_summaries')">抓取以上時間</div>
                <div class="ui divider"></div>
                <div class="custom_item" @click.prevent="refresh_data('last24_check_summaries')">抓取過去24小時</div>
                <div class="ui divider"></div>
                <div class="custom_item" @click.prevent="refresh_data('all_check_summaries')">抓取所有時間</div>
                <div class="ui divider"></div>
                <div class="item" @click.prevent="print('NormalLayout')">印出(A4)</div>
                <div class="item" @click.prevent="print('SimpleLayout')">印出(連續紙)</div>
                <div class="item">
                    <div class="ui slider checkbox">
                        <input type="checkbox"
                            v-model="is_beta"
                        >
                        <label>Beta</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CheckSummary from "@toolbox/check_summary/main.vue"
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    data() {
        return {
            sender_name: null,
            consignee_name: null,
            is_beta: true,
            is_processing: false,
            channel_name: "check_summaries",
            latest_condition_from: null,
            latest_condition_to: null,
            latest_condition_dates: null
        }
    },
    computed: {
        node() {
            return this.$store.state.provider.node
        },
        current_staff() {
            return this.$store.state.provider.current_staff
        },
        logo_url() {
            if (this.$store.state.provider.node.company_en_name) {
                return '/images/' + this.$store.state.provider.node.company_en_name.replace(/(?:^|\.|\s?)([A-Z])/g,(x,y) => { return '_' + y.toLowerCase()}).replace(/^_/, '') + '_logo.jpg'
            } else {
                switch (this.$store.state.provider.node.service_name) {
                    case "neuron":
                        return '/images/neuron_logo.png'
                        break
                    case "axon":
                        return '/images/axon_logo.png'
                        break
                    default:
                        return '/images/tw568_logo.png'
                }
            }
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        async refresh_data(category) {
            await new Promise(resolve => {
                switch (category) {
                    case "last24_check_summaries":
                        this.latest_condition_from = this.human_datetime(Date.now()-86400000, null)
                        this.latest_condition_to = this.human_datetime(Date.now(), null)
                        break
                    case "all_check_summaries":
                        this.latest_condition_from = null
                        this.latest_condition_to = null
                        break
                    case "custom_check_summaries":
                        if (this.latest_condition_dates[0] && this.latest_condition_dates[1]) {
                            this.latest_condition_from = this.$moment(this.latest_condition_dates[0]).format('YYYY-MM-DDTHH:mm:ss+08:00')
                            this.latest_condition_to = this.$moment(this.latest_condition_dates[1]).format('YYYY-MM-DDTHH:mm:ss+08:00')
                        } else {
                            throw new Error('empty_date')
                        }
                        break
                }
                resolve()
            }).catch(e => {
                switch (e.message) {
                    case 'empty_date':
                        this.$noty.error('請選擇日期')
                        break
                }
                return Promise.reject(e.message)
            })
            await this.$nextTick(() => {
                this.$bus.$emit(this.channel_name, "refresh_data")
            })
        },
        print(layout) {
            this.$bus.$emit(this.channel_name, "print", layout)
        }
    },
    components: {
        CheckSummary,
        DatePicker,
    }
}
</script>

<style scoped lang="scss">
    .ui.slider.checkbox input:checked~.box:before,
    .ui.slider.checkbox input:checked~label:before {
        background-color: #21ba45 !important;
    }
    .signal {
        border: 5px solid white;
        border-radius: 30px;
        height: 30px;
        left: 50%;
        margin: -15px 0 0 -15px;
        opacity: 0;
        position: absolute;
        top: 50%;
        width: 30px;
        animation: pulsate 1s ease-out;
        animation-iteration-count: infinite;
    }

    @keyframes pulsate {
        0% {
            transform: scale(.1);
            opacity: 0.0;
        }
        50% {
            opacity: 1;
        }
        100% {
            transform: scale(1.4);
            opacity: 0;
        }
    }
</style>
